import dynamic from 'next/dynamic';

export const RateListMGP = dynamic(() => import('./RateList').then(module => module.RateList));
